var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-1 w-full px-4 py-4 mx-auto sm:py-8 sm:px-6 lg:px-8 max-w-7xl",class:_vm.loading ? 'flex items-center justify-center' : ''},[(_vm.loading)?_c('Loading'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }